// A függvény bemeneti paraméterként várja az imgUrl-t, és visszaadja a módosított (vagy eredeti) verziót
export const normalizeImgUrlToThumb = (imgUrl) => {
    try {
        // Ellenőrizd, hogy van-e egyáltalán URL
        if (!imgUrl || typeof imgUrl !== 'string') return imgUrl;

        // Reguláris kifejezéssel vizsgáljuk a médiatári URL-eket
        const mediaPathRegex = /\/mediatar\/(file|download)\/(preview|original)/;

        // Ha egyezik a pattern, akkor átalakítjuk "thumb" típusra
        if (mediaPathRegex.test(imgUrl)) {
            return imgUrl.replace(mediaPathRegex, '/mediatar/file/thumb');
        }

        // Ha nem egyezik, akkor hagyjuk az eredeti URL-t
        return imgUrl;
    } catch (error) {
        // Ha hiba van, inkább visszaadjuk az eredeti URL-t, nehogy megdögöljön a kód
        console.error('Hiba az imgUrl normalizálásakor:', error);
        return imgUrl;
    }
};

export const normalizeImgUrlToPreview = (imgUrl) => {
    try {
        // Ellenőrizd, hogy van-e egyáltalán URL
        if (!imgUrl || typeof imgUrl !== 'string') return imgUrl;

        // Reguláris kifejezéssel vizsgáljuk a médiatári URL-eket
        const mediaPathRegex = /\/mediatar\/(file|download)\/(original|thumb)/;

        // Ha egyezik a pattern, akkor átalakítjuk "thumb" típusra
        if (mediaPathRegex.test(imgUrl)) {
            return imgUrl.replace(mediaPathRegex, '/mediatar/file/preview');
        }

        // Ha nem egyezik, akkor hagyjuk az eredeti URL-t
        return imgUrl;
    } catch (error) {
        // Ha hiba van, inkább visszaadjuk az eredeti URL-t, nehogy megdögöljön a kód
        console.error('Hiba az imgUrl normalizálásakor:', error);
        return imgUrl;
    }
};


export const normalizeImgUrlToOriginal = (imgUrl) => {
    try {
        // Ellenőrizd, hogy van-e egyáltalán URL
        if (!imgUrl || typeof imgUrl !== 'string') return imgUrl;

        // Reguláris kifejezéssel vizsgáljuk a médiatári URL-eket
        const mediaPathRegex = /\/mediatar\/(file|download)\/(preview|thumb)/;

        // Ha egyezik a pattern, akkor átalakítjuk "thumb" típusra
        if (mediaPathRegex.test(imgUrl)) {
            return imgUrl.replace(mediaPathRegex, '/mediatar/file/original');
        }

        // Ha nem egyezik, akkor hagyjuk az eredeti URL-t
        return imgUrl;
    } catch (error) {
        // Ha hiba van, inkább visszaadjuk az eredeti URL-t, nehogy megdögöljön a kód
        console.error('Hiba az imgUrl normalizálásakor:', error);
        return imgUrl;
    }
};